<kgr-page-title title="Benutzer wechseln" i18n-title></kgr-page-title>

<div class="kgr-region">
  <p class="kgr-paragraph" i18n>
    Es existieren mehrere Accounts mit derselben E-Mail-Adresse. Bitte wählen:
  </p>

  <kgr-select-login-user (loginResult)="onLoginResult($event)"></kgr-select-login-user>
</div>
